





























































import { Vue, Prop, Component } from 'vue-property-decorator';
import DateFormat from '@/shared/utils/date-format';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import toCurrency from '../directive/toCurrency';

@Component({
  filters: {
    toCurrency,
  },
})
export default class LogComponent extends Vue {
  @Prop({
    required: false,
    default: () => [],
  })
  messages?: string[];

  @Prop({
    required: false,
    default: 0,
  })
  totalValue!: number;

  @Prop({
    required: false,
    default: true,
  })
  showHeader!: boolean;

  @Prop({
    required: false,
    default: '',
  })
  observation?: string;

  @Prop({
    type: Boolean,
    required: false,
    default: false,
  })
  expanded!: boolean;

  @Prop({
    required: false,
    default: '',
  })
  currencySymbol?: string;

  @Prop({
    required: false,
    default: '',
  })
  currencyName?: string;

 @Prop({
   required: false,
   default: DateFormat.newfullDateAndTime(),
 })
  createdDate?: string;

 get date(): string {
   return DateFormat.newfullDateAndTime();
 }

 formatDate(date: string) {
   return DateFormat.fullDateAndTime(date);
 }

 copyLog(): void {
   navigator.clipboard.writeText(this.buildLogText())
     .then(() => VbSnackbarService.showSuccess('LOG copiado para a área de transferência'))
     .catch(() => VbSnackbarService.showError('Não foi possível copiar o LOG'));
 }

 private buildLogText(): string {
   const separator = '-----------------------------------------------------';
   const lines = [
     `${this.formatDate(this.createdDate!)} - Info cálculo financeiro`,
     separator,
     ...this.messages!,
   ];
   if (this.totalValue) {
     lines.push(separator, `Valor total a faturar: ${toCurrency(this.totalValue, this.currencyName, this.currencySymbol)}`);
   }
   if (this.observation) {
     lines.push(separator, `Observação: ${this.observation}`);
   }
   return lines.join('\n');
 }
}
